import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { UploadAnexoRequest } from '../../requests/compras/upload-anexo.request';
import { GetUrlAnexoResponse } from '../../responses/compras/get-url-anexo.response';
import { UploadAnexoResponse } from '../../responses/compras/upload-anexo.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class CompraAnexoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraAnexo';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public uploadAnexo(idCompra: number, base64: string, nomeArquivo: string, tamanhoBytes?: number): Observable<UploadAnexoResponse> {
    const request: UploadAnexoRequest = { base64, nomeArquivo, tamanhoBytes };
    return this.httpClient
      .post<UploadAnexoResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getUrlAnexo(idCompra: number, idAnexo: number): Observable<GetUrlAnexoResponse> {
    return this.httpClient
      .get<GetUrlAnexoResponse>(`${this.apiUrl}/${idCompra}/${idAnexo}/url`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteAnexo(idCompra: number, idAnexo: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/${idCompra}/${idAnexo}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
